<template>
  <div id="app">
    <hooper
      v-if="modal"
      :itemsToShow="1"
      :playSpeed="5000"
      :transition="1000"
      :shortDrag="false"
      @slide="slide"
      ref="slider"
    >
      <slide class="slide">
        <div class="close" @click="close">
          <i class="material-icons">close</i>
        </div>
          <img src="/campuslife/manga/img/manga_01.jpg" />
      </slide>
      <slide class="slide">
        <div class="close" @click="close">
          <i class="material-icons">close</i>
        </div>
        <img src="/campuslife/manga/img/manga_02.jpg" />
      </slide>
      <slide class="slide">
        <div class="close" @click="close">
          <i class="material-icons">close</i>
        </div>
        <img src="/campuslife/manga/img/manga_03.jpg" />
      </slide>
      <slide class="slide">
        <div class="close" @click="close">
          <i class="material-icons">close</i>
        </div>
        <img src="/campuslife/manga/img/manga_04.jpg" />
      </slide>
      <slide class="slide">
        <div class="close" @click="close">
          <i class="material-icons">close</i>
        </div>
        <img src="/campuslife/manga/img/manga_05.jpg" />
      </slide>
      <slide class="slide">
        <div class="close" @click="close">
          <i class="material-icons">close</i>
        </div>
        <img src="/campuslife/manga/img/manga_06.jpg" />
        <div class="btnApp btnClose" @click="close">閉じる</div>
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
    <div v-if="modal" class="modalManga"></div>
    <div v-else class="thumb">
      <img src="/campuslife/manga/img/manga_01.jpg" @click="open" />
      <div><div class="btnApp" @click="open">漫画を読む</div></div>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";

export default {
  name: "App",
  components: {
    Hooper,
    Slide,
    HooperNavigation,
  },
  data() {
    return {
      /*
      hooperSettings: {
        // 【props】 https://baianat.github.io/hooper/api.html#props
        itemsToShow: 1,
        centerMode: true,
        shortDrag: false,
        playSpeed: 1000,
        transition: 500,
        hoverPause: false,
        breakpoints: {
          480: {itemsToShow: 1.75 },
          640: { itemsToShow: 2.3 }
        }
      },
      */

      modal: false,
    };
  },
  methods: {
    open() {
      this.modal = true;
      this.$nextTick(() => {
        window.scrollTo(0, this.$refs.slider.$el.offsetTop);
      });
    },
    close() {
      this.modal = false;
      window.scrollTo(0, 0);
    },
    slide(slide) {
      //console.log(slide)
      if (window.ga) {
        window.ga('gtm6.send', 'event', 'manga_slider', slide.slideFrom + '_' + slide.currentSlide, 1)
      }
    },

/*
    beforeSlide() {

      window.addEventListener('touchmove',function(e){
                        
if(e.touches.length > 1){
          console.log(slide);
          window.alert('2本指で動かした');
        }
      },false);
    },
*/





  },
};
</script>

<style>
#app {
  margin-bottom: 100px;
}
.hooper {
  position: relative;
  z-index: 100;
}
h2 {
  background: #fff3dd;
  padding: 10px 20px;
}
.hooper-next,
.hooper-prev {
  background: #fff;
}
.hooper-navigation {
  display: none;
}

@media screen and (min-width: 766px) {
  .hooper-navigation {
    display: block;
  }
  #entry-content {
    width: 1000px;
    margin: 0 auto;
  }
  .hooper {
    width: 100%;
    text-align: center;
  }
  .hooper img {
    max-width: 500px;
    width: auto;
    height: 75%;
  }
}

.last {
  margin: 0 auto;
  text-align: center;
}
.modalManga {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
}
body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
}
.slide {
  min-height: -webkit-fill-available;
  background: #000;
  color: #fff;
  align-items: center;
  margin: 0 auto;
  position: relative;
  display: flex;
  text-align: center;
  position: relative;
}
.slide .close {
  width: 30px;
  height: 30px;
  background: #111111;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 50%;
}
.slide .close .material-icons {
  font-size: 30px;
}
.slide img {
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.hooper-track {
  align-items: center;
}
.thumb {
  text-align: center;
}
.thumb img {
  width: 75%;
}
.hooper {
  display: flex;
  background: #000;
  align-items: center;
  height: 100%;
  height: -webkit-fill-available;
  min-height: -webkit-fill-available;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.btnApp,
a.btnApp {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.5;
  position: relative;
  display: inline-block;
  margin: 1rem 0;
  padding: 1rem 1.5rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  letter-spacing: 0.1em;
  color: #212529;
  border-radius: 0.5rem;
  color: #fff;
  background-color: #b9e552;
}
.btnApp:hover,
a.btnApp:hover {
  color: #fff;
  background: #b9ff52;
}
.btnClose,
.btnClose:hover {
  position: absolute;
  bottom: 5px;
  margin: 0 auto;
  background: #eee;
  border: 1px solid #ededed;
  color: #333;
  width: 150px;
  left: calc(50% - 75px);
}
.shokuiku-box {
  margin: 20px 0;
  background: #fff3dd;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
}
.shokuiku-box figure {
  display: block;
  margin: 0;
}
.shokuiku-box figure img {
  width: 100%;
  height: auto;
}

.tanpact-box {
  width: 100%;
  max-width: 500px;
  margin: 15px auto;
  padding: 1px;
  background: #eee;
  background-size: auto auto;
  background-color: rgba(240, 240, 240, 1);
  background-image: repeating-linear-gradient(
    125deg,
    transparent,
    transparent 200px,
    rgba(255, 255, 255, 1) 200px,
    rgba(255, 255, 255, 1) 400px
  );
}
.tanpact-box h1 {
  font-size: 16px;
  padding: 10px;
  margin: 0;
  text-align: center;
}
.tanpact-box p {
  font-size: 16px;
  padding: 0 10px;
  margin: 10px auto;
  line-height: 1.5;
  text-align: left;
}
.tanpact-box figure {
  margin: 10px;
  padding: 1px;
  border: none;
  font-weight: bold;
  text-align: center;
}
.tanpact-box figure figcaption {
  font-size: 14px;
  font-weight: normal;
}
.tanpact-box figure img {
  width: 90%;
}

body.entry .shokuiku-box p:last-child {
  margin-bottom: 0;
}

body.entry .entry-text-body p {
  margin-bottom: 1.5em;
}
figure.pic {
  margin: 10px;
  text-align: center;
}
figure.pic img {
  margin: 10px;
  width: 100%;
}
.banner {
  text-align: center;
  margin: 20px auto;
  width: 300px;
  animation: click 3s infinite;
  position: relative;
  background-color: rgb(235, 97, 0);
  color: #fff;
  z-index: 2;
  box-sizing: border-box;
  border-radius: 10px;

  border: 2px solid transparent;
  box-shadow: 0 3px 0 rgba(109, 45, 0, 0.432);
}
.banner img {
  max-width: 300px;
}
.banner:hover {
  background-color: #fff;

  animation: click 2.5s infinite;
  border: 2px solid rgb(235, 97, 0);
  color: rgb(235, 97, 0);
}
.banner::before,
.banner::after {
  top: 0;
  width: 50%;
  height: 100%;
  transition: all 0.5s;
  position: absolute;
  z-index: -1;
  display: block;
  content: "";
  background-color: rgb(235, 97, 0);
}

.banner::before {
  right: 0;
}
.banner::after {
  left: 0;
}
.banner a {
  color: #fff;
  display: block;
  padding: 30px;
  font-size: 26px;
  font-weight: bold;
  position: relative;
}
.banner a:before {
  position: absolute;
  z-index: -1;
  display: block;
  content: "";
  width: 0;
  height: 0;
  top: calc(50% - 12.5px);
  right: 10px;
  border-left: 15px solid #fff;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
}
.banner a:hover {
  color: rgb(235, 97, 0);
}
.banner a:hover:before {
  position: absolute;
  z-index: -1;
  display: block;
  content: "";
  width: 0;
  height: 0;
  right: 10px;
  border-left: 15px solid rgb(235, 97, 0);
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
}

.banner:hover::before,
.banner:hover::after {
  width: 0;
}
.banner.tanpactBanner {
  background-color: #3bb9ea;
}
.banner.tanpactBanner:hover {
  background-color: #fff;

  animation: click 2.5s infinite;
  border: 2px solid #3bb9ea;
  color: #3bb9ea;
}
.banner.tanpactBanner::before,
.banner.tanpactBanner::after {
  background-color: #3bb9ea;
}

.banner.tanpactBanner a:hover {
  color: #3bb9ea;
}
.banner.tanpactBanner a:hover:before {
  border-left: 15px solid #3bb9ea;
}

@media screen and (min-width: 766px) {
  .banner {
    width: 600px;
  }
  .banner br {
    display: none;
  }
  h2 {
    background: #fff3dd;
    padding: 20px;
  }
  .hooper {
    display: flex;
    background: #000;
    align-items: center;
    height: 100%;
  }
  .slide img {
    width: auto;
    height: 75%;
    margin: 0 auto;
  }
}
@keyframes click {
  50% {
    box-shadow: 0 3px 0 rgb(0, 0, 0, 0.3);
    top: 0px;
  }
  60% {
    box-shadow: 0 0 0 rgb(0, 0, 0, 0.3);
    top: 3px;
  }
  70% {
    box-shadow: 0 3px 0 rgb(0, 0, 0, 0.3);
    top: 0px;
  }
  80% {
    box-shadow: 0 0 0 rgb(0, 0, 0, 0.3);
    top: 3px;
  }
  90% {
    box-shadow: 0 3px 0 rgb(0, 0, 0, 0.3);
    top: 0px;
  }
}
</style>
